$(document).ready(function(){
    
    // order step #1 / cart
    if($("#orderCart").length) {
        
        $('#f_country_code').change(function(){
			var tmpLng = $(this).val();
			$('.fd').each(function(){
				if($(this).hasClass('fd_'+tmpLng))
				{
					$(this).show();
				}
				else
				{
					$(this).hide();
				}
			})
		})
    };

    // order step #2 / delivery & payment
    if($("#orderData").length) {
    
        $("#zmena_krajiny").change(function() {
            window.location.href = "?country_code="+$("#zmena_krajiny option:selected").val();
        });
        
        $('.label_check, .label_radio').click(function(){	
			setupValue();
		});
			
		setupValue();

		$(window).load(function()
		{
            // nesmie sa skryvat cez display kym sa nenacita cela mapa, inak je rozbita
            $('.form_item.map').hide().css('visibility', 'visible');
            var checked = $($('input[name="delivery_service"]:checked')[0]);
			changeStoreMap(checked);
            changeZasielkovna(checked);
            changeDpdPickup(checked);
		 });
			
        // show/hide delivery additional messages
        $('input[name="delivery_service"]').change(function()
        {
            changeStoreMap($(this));
            changeZasielkovna($(this));
            changeDpdPickup($(this));
            
            var delivery = $('input[name=delivery_service]:checked').val();
            if (delivery == "store_dp")
            {
                $('input#billing_namieste_hotovostkarta').removeAttr('disabled').removeAttr('dontallow');
                $('input#billing_namieste_hotovostkarta').closest("label").removeClass('disabled');
                $('input#billing_namieste').prop('checked',false).attr('disabled','true').attr('dontallow','true');
                $('input#billing_namieste').closest("label").addClass('disabled').removeClass('r_on');
            }
            else
            {
                $('input#billing_namieste').removeAttr('disabled').removeAttr('dontallow');
                $('input#billing_namieste').closest("label").removeClass('disabled');
                $('input#billing_namieste_hotovostkarta').prop('checked',false).attr('disabled','true').attr('dontallow','true');
                $('input#billing_namieste_hotovostkarta').closest("label").addClass('disabled').removeClass('r_on');
            }
        });
	}
});

function changeStoreMap(current)
{
	var checked_input = current.val();	
	// hide other stores maps
	if (checked_input == 'store_dp')
	{
		 var other_stores = $('#store_dp.map').not('#' + checked_input);
	   
		 if (other_stores.length >= 1)
		 {
				 other_stores.fadeOut(500, function()
				 {
						$('.form.standard h3.our_shop').fadeIn(500);
						$('#' + checked_input).fadeIn(500);
				 });
		 }
		 else
		 {
				 $('.form.standard h3.our_shop').fadeIn(500);
				 $('#' + checked_input).fadeIn(500);
		 }
	}
	else
	{
		 $('.form.standard h3.our_shop').fadeOut(500);
		 $('#store_dp.map').fadeOut(500);
	}
}

function changeZasielkovna(current)
{
	var checked_input = current.val();
	// hide other stores maps
	if (checked_input == 'zasielkovna')
	{
		$('.zasielkovna_detail').fadeIn(500);
	}
	else
	{
		$('.zasielkovna_detail').fadeOut(500);
	}
}

function changeDpdPickup(current)
{
    var checked_input = current.val();
	// hide other stores maps
	if (checked_input == 'dpd_pickup')
	{
		$('.dpd_pickup_detail').fadeIn(500);
        dpdWidgetOpen();
    }
	else
	{
		$('.dpd_pickup_detail').fadeOut(500);
	}
}

function dpdWidgetOpen()
{
     if (typeof dpdWidget !== 'undefined')
     {
        if (!$("#dpd-widget-container").length) {
            //console.log("el not exist, create");
            $("body").append($('<div id="dpd-widget-overlay"><div id="dpd-widget-container"></div></div>'));
            document.getElementById("dpd-widget-overlay").addEventListener("click", function() {
                dpdWidgetOverlay_hide();
            });
        }
        $("#dpd-widget-overlay").fadeIn(100).addClass('open');
        
        dpdWidget
        //.open()
        .attach(document.getElementById('dpd-widget-container'))
        .then(pudo => {                
            $('#dpd-place-id').val(pudo.id);
            $('#dpd-place-name').val(pudo.name + ", "+ pudo.addressText);
            $('.dpd-selected-place').text(pudo.name + ", "+ pudo.addressText);
            dpdWidgetOverlay_hide();
        })
        .catch(code => {
            switch (code) {
                case 'closed_by_user':
                    $('.dpd-selected-place .error').show();
                    dpdWidgetOverlay_hide();
                break;
                case 'closed':
                    $('.dpd-selected-place .error').hide();
                    dpdWidgetOverlay_hide();
                break;
                // handle other codes.
                default:
                break;
            }
        });
    }
}
function dpdWidgetOverlay_hide()
{
     $("#dpd-widget-overlay").fadeOut(100).removeClass('open');
}

$(document).on('click', '#dpd-widget-open', function(e) {
    e.preventDefault();
    dpdWidgetOpen()
});

function setupValue()
{
    var delivery = $('input[name=delivery_service]:checked').val();
    var billing = $('input[name=billing_service]:checked').val();
    
    // re-enable all possibilities
    $('input[name=delivery_service]').each(function(){
        if (!$(this).attr('dontallow'))
        {
            $(this).removeAttr('disabled');
        }
    });
    
    $('input[name=billing_service]').each(function(){
        if (!$(this).attr('dontallow'))
        {
            $(this).removeAttr('disabled');
        }
    });
}		